import { useState } from 'react';
import { OderCardHeader } from '../OrderComponents.jsx';
import {
  MultiplePaymentsTable,
  NextQuotasTable,
} from '../../../../common/Tables/Tables.jsx';
import {
  multiplePaymentsTableHeader,
  nextQuotaTableHeader,
} from '../../../../../assets/helpers/tables.js';
import {
  NaNtoNumber,
  filterById,
  returnIGTF,
  isPaymentMethodZelleOrPaypal,
  validateReferenceLength,
  validateAndSet,
  validatePaymentDifference,
  validateProductsPayment,
} from '../../../../../assets/helpers/funciones.js';
import {
  paymentMethods,
  paymentTypeOptions,
  paymentType,
  transactionTypes,
} from '../../../../../assets/helpers/options.js';
import authService from '../../../../../services/authService.js';
import { stripeService } from '../../../../../services/stripeService';
import { bancamigaService } from '../../../../../services/bancamigaService';
import { notify } from '../../../../../assets/helpers/toast';
import {
  secondQuotaTime,
  casheaQuotaTime,
} from '../../../../../assets/helpers/variables';
import { PaymentsForm } from '../../../../common/Forms/Form.jsx';
import { ActionButton } from '../../../../common/Buttons/Buttons.jsx';
import {
  NewPaymentModal,
  CashBackComponent,
} from '../../../Landing/LandingComponents/LandingModals';
import { CashbackModal } from '../../../Landing/LandingComponents/CashbackModal';
import { CasheaLinkFlow } from '../../../Landing/LandingForms/CasheaLink/CasheaLinkFlow.jsx';
import moment from 'moment';

import '../OrderComponent.scss';
import { LoadSpinner } from '../../../../common/LoadSpinner/LoadSpinner.jsx';
import { membershipService } from '../../../../../services/membershipService.js';

import { salesRoles } from '../../../../../assets/helpers/roles';

export const PaymentCard = (props) => {
  const { label, membership, card } = props;
  const {
    actions,
    fileUploaded,
    setFileUploaded,
    cashBackImage,
    setCashBackImage,
    errorsDropzone,
    getPaymentDateRate,
    cashReceiverOptions,
    transactionType,
    isZeroInitialCashea,
    showErrorAPI,
    casheaLink,
  } = card;
  const { register, handleSubmit, errors, setValue, watch, control, setError, } =
    card.form;

  const paymemtMethodOptions = card?.options?.paymentMethods;
  const [isloading, setIsloading] = useState(false);

  const getPaymentsData = (file, index) => {
    if (
      paymemtMethodOptions?.length > 0 &&
      [
        paymentMethods?.TRANSFERENCIA_BANESCO,
        paymentMethods?.TRANSFERENCIA_BANCAMIGA,
        paymentMethods?.TRANSFERENCIA_BANPLUS,
        paymentMethods?.TRANSFERENCIA_BNC,
        paymentMethods?.TRANSFERENCIA_MERCANTIL,
        paymentMethods?.PAGO_MÓVIL_BNC,
        paymentMethods?.PAGO_MOVIL_BANPLUS,
        paymentMethods?.PAGO_MÓVIL_BANCAMIGA,
        paymentMethods?.PAGO_MÓVIL_BANESCO,
        paymentMethods?.PAGO_MÓVIL_MERCANTIL,
        paymentMethods?.PUNTO_DE_VENTA,
      ].includes(
        filterById(paymemtMethodOptions, watch(`method${index}`))?.name
      )
    ) {
      const formData = new FormData();
      formData.append('file', file);
      setIsloading(true);
      membershipService
        .getPaymentsData(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            const res = response?.data?.[0]?.data;
            if (
              paymemtMethodOptions?.length > 0 &&
              [
                paymentMethods?.TRANSFERENCIA_BANESCO,
                paymentMethods?.TRANSFERENCIA_BANCAMIGA,
                paymentMethods?.TRANSFERENCIA_BANPLUS,
                paymentMethods?.TRANSFERENCIA_BNC,
                paymentMethods?.TRANSFERENCIA_MERCANTIL,
                paymentMethods?.PAGO_MÓVIL_BNC,
                paymentMethods?.PAGO_MOVIL_BANPLUS,
                paymentMethods?.PAGO_MÓVIL_BANESCO,
                paymentMethods?.PAGO_MÓVIL_MERCANTIL,
                paymentMethods?.PUNTO_DE_VENTA,
              ].includes(
                filterById(paymemtMethodOptions, watch(`method${index}`))?.name
              )
            ) {
              const ref =
                res?.operation_id === null || res?.operation_id === ''
                  ? res?.reference_id
                  : res?.operation_id;
              validateAndSet(`reference${index}`, ref, setValue, watch);
              setPayment((prevState) => {
                return {
                  ...prevState,
                  reference: ref,
                };
              });

              setIsloading(false);
            } else if (
              paymemtMethodOptions?.length > 0 &&
              [paymentMethods?.PAGO_MÓVIL_BANCAMIGA].includes(
                filterById(paymemtMethodOptions, watch(`method${index}`))?.name
              )
            ) {
              const ref =
                res?.operation_id === null || res?.operation_id === ''
                  ? res?.reference_id
                  : res?.operation_id;
              validateAndSet(`reference${index}`, ref, setValue, watch);
              validateAndSet(
                `date${index}`,
                new Date(moment(res?.date).endOf('day')),
                setValue,
                watch
              );

              setPayment((prevState) => {
                return {
                  ...prevState,
                  reference: ref,
                };
              });
              setIsloading(false);
            } else {
              setIsloading(false);
              notify(`${response.message}` || 'error', 'error');
            }
          } else {
            setIsloading(false);
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    } else {
      setIsloading(false);
      return true;
    }
  };

  const [open, setOpen] = useState(true);
  const [selectedMethod, setSelectedMethod] = useState('');
  const [stripeModal, setStripeModal] = useState({
    isOpen: false,
    methods: [],
  });

  const [cashbackModal, setCashbackModal] = useState({
    isOpen: false,
  });

  const [payment, setPayment] = useState({
    amount: 1,
    amountBsS: 1,
    methods: [],
    reference: '',
    owner: '',
  });

  const handleCashbackBs = (index) => {
    let cashbackMethodsQuantity = parseFloat(watch('cashbackMethodsQuantity'));
    let amountReturned = parseFloat(watch(`amountReturned`));

    setValue(
      `returnedAmountBsS${index}`,
      (parseFloat(watch(`returnedAmount${index}`)) * card.dollarRate)?.toFixed(
        2
      )
    );

    // Automatically set the amount for the last method
    if (index === cashbackMethodsQuantity - 2) {
      let paid = 0;
      for (let i = 0; i < cashbackMethodsQuantity - 1; i++) {
        paid = paid + parseFloat(watch(`returnedAmount${i}`));
      }
      if (amountReturned - paid <= 0) {
        notify(
          'La suma de los montos no puede superar el vuelto a entregar',
          'error'
        );
        for (let j = 0; j < cashbackMethodsQuantity; j++) {
          setValue(`returnedAmount${j}`, 0);
          setValue(`returnedAmountBsS${j}`, 0);
        }
        return null;
      }

      setValue(
        `returnedAmount${cashbackMethodsQuantity - 1}`,
        (amountReturned - paid)?.toFixed(2)
      );
      setValue(
        `returnedAmountBsS${cashbackMethodsQuantity - 1}`,
        (
          parseFloat(watch(`returnedAmount${cashbackMethodsQuantity - 1}`)) *
          card.dollarRate
        )?.toFixed(2)
      );
    }
  };

  const handleDrop = (event, index) => {
    let file = '';
    // File added on drop
    if (event?.dataTransfer?.files) {
      file = Array?.from(event?.dataTransfer?.files)[0];
    }

    let maxWeight = 5; //Peso en MB

    // File added on Click
    if (event?.target?.files?.length > 0) {
      file = event?.target?.files[0];
    }

    if (
      !['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(
        file.type
      )
    ) {
      notify('Agregar un formato valido de imagen', 'error');
      return null;
    }
    if (file.size * 0.000001 > maxWeight) {
      notify(`La imagen no debe superar los ${maxWeight} MB`, 'error');
    }
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: file,
      };
    });
  };

  const handleCashbackMethodsQuantity = () => {
    for (let i = 0; i < 3; i++) {
      setValue(`returnedMethod${i}`, '');
      setValue(`returnedAmount${i}`, '');
      setValue(`returnedAmountBsS${i}`, '');
      setCashBackImage((prevState) => {
        return {
          ...prevState,
          [`image${i}`]: '',
        };
      });
    }

    if (watch('cashbackMethodsQuantity') === '1') {
      setValue(`returnedAmount0`, watch('amountReturned'));
      setValue(
        `returnedAmountBsS0`,
        (parseFloat(watch('amountReturned')) * card.dollarRate)?.toFixed(2)
      );
    }
  };

  const removeFile = (index) => {
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: '',
      };
    });
  };

  const validateButtonName = () => {
    let label = 'Pagar';
    // let action = onSubmit;
    let submit = actions?.pay;

    if (
      [paymentType?.COURTESY, paymentType?.PENDING].includes(
        watch('paymentType')
      ) || [paymentType?.COURTESY, paymentType?.PENDING].includes(
        watch('paymentTypeFake')
      )
    ) {
      label = `Registrar pago ${watch('paymentTypeFake') || watch('paymentType')}`;
      submit = actions?.pay;
      return <ActionButton label={label} action={submit} />;
    }

    // Con inicial 0 en Cashea no hay referencia ni comprobante de pago,
    // solo se exige la referencia de Cashea
    if (isZeroInitialCashea) {
      return watch('referenceCashea') ? (
        <ActionButton label={label} action={submit} />
      ) : null;
    }

    const lastIndex = parseFloat(watch('paymentMethodsQuantity')) - 1;

    if (!watch(`reference${lastIndex}`) && !fileUploaded[lastIndex]) {
      return null;
    }

    return <ActionButton label={label} action={submit} />;
  };

  const handleGenericPaymentMethods = (index) => {
    setValue(`date${index}`, '');
    setValue(`bank${index}`, '');
    setValue(`phone${index}`, '');
    setValue(`reference${index}`, '');

    let selectedMethod = filterById(
      paymemtMethodOptions,
      watch('paymentOption')
    );
    setValue(`method${index}`, selectedMethod?._id);
  };

  const handleOwnerChange = (e) => {
    const { value } = e?.target;
    setPayment((prevState) => {
      return {
        ...prevState,
        owner: value,
      };
    });
    setValue(`owner${payment?.paymentNumber}`, value);
  };

  const calculateCashBack = (paymentNumber) => {
    const paymentMethodsQuantity = NaNtoNumber(watch('paymentMethodsQuantity'));
    if (paymentNumber !== paymentMethodsQuantity - 1) {
      return null;
    }

    let totalPaid = 0;
    let totalCashPaid = 0;
    let totalAmount = 0;

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      totalAmount =
        totalAmount + NaNtoNumber(parseFloat(watch(`finalAmount${i}`)));
      totalCashPaid =
        totalCashPaid + NaNtoNumber(parseFloat(watch(`paid${i}`)));
      totalPaid =
        totalPaid +
        (NaNtoNumber(parseFloat(watch(`paid${i}`))) > 0
          ? NaNtoNumber(parseFloat(watch(`paid${i}`)))
          : NaNtoNumber(parseFloat(watch(`finalAmount${i}`))));
    }

    let amountReturned = totalPaid - totalAmount;

    if (amountReturned > 0) {
      setValue('paid', totalCashPaid);
      setValue(
        'paidBsS',
        (parseFloat(watch('paid')) * card.dollarRate)?.toFixed(2)
      );
      setValue('amountReturned', amountReturned.toFixed(2));
      setValue(
        'amountReturnedBsS',
        (amountReturned * card.dollarRate).toFixed(2)
      );
      setValue('cashbackMethodsQuantity', 1);
      setValue(`returnedAmount0`, Math.abs(amountReturned));
      setValue(
        `returnedAmountBsS0`,
        (parseFloat(watch('amountReturned')) * card.dollarRate)?.toFixed(2)
      );
    }
  };

  const validateBancamigaPM = async (index, PMpaymentMethod) => {
    let data = {
      date: watch(`date${index}`)
        ? moment(watch(`date${index}`)).format('YYYY-MM-DD')
        : '',
      bank: watch(`bank${index}`), // Bancamiga by default
      phone: '58' + watch(`phone${index}`),
      reference: watch(`reference${index}`),
      method: PMpaymentMethod?._id,
    };

    return bancamigaService
      .checkPayment(data)
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.wasFound) {
            return true;
          } else {
            notify(`No se pudo validar el pago movil`, 'error');
            return false;
          }
        } else {
          notify(`${response.message}`, 'error');
          return false;
        }
      })
      .catch(() => { });
  };

  const validatePagoMovil = async (params, index, PMpaymentMethod) => {
    let isValid = true;
    if (watch(`phone${index}`)?.length !== 10) {
      setError(`phone${index}`, {
        type: 'custom',
        message: 'Ingrese un numero de telefono valido: Ejemplo: 4143579865',
      });
      return false;
    } else {
      setError(`phone${index}`, { type: 'custom', message: '' });
    }

    for (let i = 0; i < params?.length; i++) {
      if (!watch(`${params[i]}${index}`)) {
        setError(`${params[i]}${index}`, {
          type: 'custom',
          message: 'Obligatorio',
        });
        isValid = false;
      }
    }

    if (!authService?.getUser()) {
      // Validate PM against bancamiga API
      let validPM = await validateBancamigaPM(index, PMpaymentMethod);

      if (!validPM) {
        return false;
      }
    }

    return isValid;
  };

  const cancelPayment = (paymentNumber) => {
    let images = [...fileUploaded];
    images[paymentNumber] = '';
    // Remove image if not edit
    if (!payment?.isEdit) {
      setValue(`reference${paymentNumber}`, '');
      setFileUploaded(images);
    }
    setPayment((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        methods: [],
        paymentNumber: paymentNumber,
        reference: '',
        owner: '',
      };
    });
  };

  const acceptPayment = async () => {
    let PMpaymentMethod = filterById(
      paymemtMethodOptions,
      watch('paymentOption')
    );

    // Validate PM and transfer ref length
    if (!validateReferenceLength(PMpaymentMethod, payment)) {
      return null;
    }

    // IF the payment is made in CASH then set the ref message
    for (let i = 0; i < payment?.methods?.length; i++) {
      if ([paymentMethods.CASH_BS].includes(payment?.methods[i]?.name)) {
        setValue(`reference${payment?.paymentNumber}`, 'PAGO EFECTIVO');
      }
    }

    const params = ['phone', 'bank', 'date'];

    // Valida los Pago movil de bancamigasolamente
    if (
      [paymentMethods?.PAGO_MÓVIL_BANCAMIGA]?.includes(PMpaymentMethod?.name)
    ) {
      const isPMValid = await validatePagoMovil(
        params,
        payment?.paymentNumber,
        PMpaymentMethod
      );
      if (!isPMValid) {
        return null;
      }
    }
    // Validate If first Image is Up
    if (
      ![paymentMethods.PUNTO_DE_VENTA, paymentMethods.TDC]?.includes(
        payment?.methods[0]?.name
      ) &&
      ((!watch(`reference${payment?.paymentNumber}`) &&
        !isPaymentMethodZelleOrPaypal(
          watch(`method${payment?.paymentNumber}`),
          paymemtMethodOptions
        )) ||
        !fileUploaded[payment?.paymentNumber])
    ) {
      notify('Subir imagen y datos de referencia de pago', 'error');
      return null;
    }

    // IF method is cash dont ask for reference and pay

    setSelectedMethod('');

    calculateCashBack(payment?.paymentNumber);

    setPayment((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        methods: [],
        paymentNumber: '',
        reference: '',
        selectedMembership: membership?._id,
      };
    });
  };

  const handleReferenceChange = (e) => {
    const { value } = e?.target;
    setPayment((prevState) => {
      return {
        ...prevState,
        reference: value,
      };
    });

    setValue(`reference${payment?.paymentNumber}`, value);
  };

  const handleBillAmountChange = () => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    let acumulated = 0;
    let finalPrice = parseFloat(watch('finalPrice'));
    let billAmount = parseFloat(watch('billAmount'));

    const amount = parseFloat((billAmount / paymentMethodsQuantity).toFixed(2));

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      acumulated = acumulated + amount;
      setValue(`amount${i}`, amount.toFixed(2));

      if (i === paymentMethodsQuantity - 1) {
        // Calcula el residuo de la division y sumalo
        const rest = billAmount - acumulated;
        setValue(`amount${i}`, (amount + rest).toFixed(2));
      }
      setValue(
        `amountBsS${i}`,
        (parseFloat(watch(`amount${i}`)) * card?.dollarRate).toFixed(2)
      );
    }

    if (watch('paymentType') === paymentType?.FINANCIADO) {
      setValue('financialAmount0', finalPrice - billAmount);
      setValue(
        'financialAmountBsS0',
        (parseFloat(watch('financialAmount0')) * card?.dollarRate).toFixed(2)
      );
    }
  };

  const setPaymentType = () => {
    let paymentTypeVAR = watch('paymentType');
    if ([paymentType?.DE_CONTADO].includes(paymentTypeVAR)) {
      //FInal price unlike afiliation landing
      setValue('amount0', watch('finalPrice'));
      setValue(
        'amountBsS0',
        (parseFloat(watch(`finalPrice`)) * card?.dollarRate).toFixed(2)
      );
      setValue('paymentMethodsQuantity', '1');
      setValue('billAmount', watch('finalPrice'));
    }

    if (paymentTypeVAR === paymentType?.FINANCIADO) {
      setValue('paymentMethodsQuantity', '1');
      setValue('billAmount', '');
    }

    if (paymentTypeVAR === paymentType?.CASHEA) {
      setValue('paymentMethodsQuantity', '1');
      setValue('billAmount', '');
      setValue('initial', '');
      setValue('numCasheaDues', '');
    }
  };

  const selectUniquePayment = (rate) => {
    // Set Transaction amount depending on the payment type
    if (watch('paymentType') === paymentType?.DE_CONTADO) {
      setValue('billAmount', watch('finalPrice'));
    }

    // Preload Payment Methods and amounts
    if (parseFloat(watch('paymentMethodsQuantity')) === 1) {
      setValue('method0', '');
      setValue('amount0', watch('billAmount'));
      handleAmountChange('0');
    } else {
      for (let i = 0; i < parseFloat(watch('paymentMethodsQuantity')); i++) {
        setValue(`method${i}`, '');
        setValue(`amount${i}`, 0);
        handleAmountChange(i);
      }
    }
  };

  const openNewStripeModal = (amount, paymentNumber, igtf) => {
    let data = {
      amount: amount,
      membership: membership?._id,
      paymentType: watch('paymentType'),
      igtf: igtf,
    };

    stripeService
      .paymentIntent(data)
      .then((response) => {
        if (response.status === 200) {
          handleStipeModal(amount, paymentNumber);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const handleStipeModal = (amount, paymentNumber) => {
    let selectedPaymentMethods = paymemtMethodOptions.filter(
      (p) => p.name === paymentMethods?.STRIPE
    );

    setStripeModal((prevState) => {
      return {
        ...prevState,
        isOpen: !stripeModal?.isOpen,
        methods: selectedPaymentMethods,
        paymentNumber:
          paymentNumber || paymentNumber === 0 ? paymentNumber : '',
        amount: amount ? amount : 0,
        amountBsS: amount ? amount * card?.dollarRate : 0,
        selectedMembership: membership?._id,
      };
    });
  };

  // New Logic
  const handleAmountChange = (index) => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    let acumulatedAmount = 0;

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      if (i !== index + 1) {
        acumulatedAmount = acumulatedAmount + parseFloat(watch(`amount${i}`));
      }
    }
    const nextAmount = parseFloat(watch('billAmount') - acumulatedAmount);

    if (nextAmount > 0) {
      setValue(`amount${index + 1}`, nextAmount.toFixed(2));
      setValue(
        `amountBsS${index + 1}`,
        (watch(`amount${index + 1}`) * card?.dollarRate).toFixed(2)
      );
      calculateIGTF(index + 1);
    }

    // Calculate IGTF
    setValue(
      `amountBsS${index}`,
      NaNtoNumber(
        parseFloat(watch(`amount${index}`)) * card?.dollarRate
      ).toFixed(2)
    );
    calculateIGTF(index);
    calculateIGTFTotal();
  };

  const handleIGTFChange = (index) => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));
    if (index < paymentMethodsQuantity) {
      let acumulatedIGTF = 0;
      // alculate next amount
      for (let i = 0; i < paymentMethodsQuantity; i++) {
        if (i !== index + 1) {
          acumulatedIGTF = acumulatedIGTF + parseFloat(watch(`IGTF${i}`));
        }
      }
      const nextIGTF = parseFloat(watch('totalIGTF') - acumulatedIGTF);

      if (nextIGTF > 0) {
        setValue(`IGTF${index + 1}`, nextIGTF.toFixed(2));
      }

      // Calculate final amount with IGTF in $ and BS
      for (let j = 0; j < paymentMethodsQuantity; j++) {
        setValue(
          `finalAmount${j}`,
          (
            parseFloat(watch(`amount${j}`)) + parseFloat(watch(`IGTF${j}`))
          ).toFixed(2)
        );
        setValue(
          `finalAmountBsS${j}`,
          (parseFloat(watch(`finalAmount${j}`)) * card?.dollarRate).toFixed(2)
        );
      }
    }
  };

  const calculateIGTFTotal = () => {
    let totalIGTF = 0;

    for (let i = 0; i < watch('paymentMethodsQuantity'); i++) {
      const method = filterById(paymemtMethodOptions, watch(`method${i}`));
      if (method && !['BsS'].includes(method.currency)) {
        totalIGTF = totalIGTF + parseFloat(watch(`amount${i}`));
      }
      setValue('totalIGTF', ((totalIGTF * returnIGTF()) / 100)?.toFixed(2));
    }
  };

  const calculateIGTF = (index) => {
    const method = filterById(paymemtMethodOptions, watch(`method${index}`));
    // Calculate IGTF
    if (method && !['BsS'].includes(method.currency)) {
      setValue(
        `IGTF${index}`,
        (watch(`amount${index}`) * (returnIGTF() / 100)).toFixed(2)
      );
    } else {
      setValue(`IGTF${index}`, 0);
    }
    const finalAmount =
      parseFloat(watch(`amount${index}`)) + parseFloat(watch(`IGTF${index}`));
    setValue(`finalAmount${index}`, NaNtoNumber(finalAmount).toFixed(2));
    setValue(`finalAmountBsS${index}`, watch(`amountBsS${index}`));
  };

  const handleMethodChange = (index) => {
    calculateIGTF(index);
    calculateIGTFTotal();
    setValue(`reference${index}`, '');
    let images = [...fileUploaded];

    images[index] = '';
    setFileUploaded(images);
  };

  // Payment modal Logix
  const handlePaymentModal = (paymentNumber) => {
    if (validateProductsPayment(transactionType) && !watch(`paymentTypeFake`)) {
      notify('Debe seleccionar un tipo de pago valido', 'error');
      return null;
    }
    const method = filterById(
      paymemtMethodOptions,
      watch(`method${paymentNumber}`)
    );

    if (method.name === paymentMethods.STRIPE && !authService?.getUser()) {
      openNewStripeModal(
        parseFloat(watch(`finalAmount${paymentNumber}`)),
        paymentNumber,
        false
      );
    } else {
      setValue('paymentOption', method._id);
      setPayment((prevState) => {
        return {
          ...prevState,
          isOpen: true,
          isEdit:
            watch(`reference${paymentNumber}`) || fileUploaded[paymentNumber]
              ? true
              : false,
          amount: parseFloat(watch(`finalAmount${paymentNumber}`)),
          amountBsS: parseFloat(watch(`finalAmountBsS${paymentNumber}`)),
          methods: [method],
          paymentNumber: paymentNumber,
          reference: watch(`reference${paymentNumber}`),
          owner: watch(`owner${paymentNumber}`),
          selectedMembership: membership?._id,
        };
      });
    }
  };

  const validateIfCanPay = (index) => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    const billAmount = parseFloat(watch('billAmount'));
    const totalIGTF = parseFloat(watch('totalIGTF'));

    let accumulatedAmount = 0;
    let accumulatedIGTF = 0;
    for (let i = 0; i < paymentMethodsQuantity; i++) {
      accumulatedAmount = accumulatedAmount + parseFloat(watch(`amount${i}`));
      accumulatedIGTF = accumulatedIGTF + parseFloat(watch(`IGTF${i}`));

      if (!watch(`method${i}`)) {
        return false;
      }
    }

    if (authService.getUser()) {
      return validatePaymentDifference(accumulatedAmount, billAmount);
    }

    if (
      accumulatedAmount !== billAmount ||
      parseFloat(accumulatedIGTF.toFixed(2)) !== totalIGTF
    ) {
      return false;
    }

    // First payment mus be executed before enabiling other buttons
    if (index !== 0 && !watch(`reference${0}`) && !fileUploaded[0]) {
      return false;
    } else return true;
  };

  const handleCasheaInitial = (e) => {
    const initial = parseFloat(watch(`initial`));
    let paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    setValue('billAmount', initial.toFixed(2));

    if (paymentMethodsQuantity === 1) {
      setValue('amount0', watch('billAmount'));
      setValue('amountBsS0', (watch('amount0') * card?.dollarRate).toFixed(2));
    }

    // Cantidad de metodos de pago = 0
    setValue('numCasheaDues', '');
  };

  const handleCasheaQuotas = () => {
    const initial = parseFloat(watch(`initial`));
    const finalPrice = parseFloat(watch(`finalPrice`));
    const numCasheaDues = parseFloat(watch(`numCasheaDues`));
    const remaining = finalPrice - initial;

    for (let i = 0; i < numCasheaDues; i++) {
      setValue(`financialAmount${i}`, (remaining / numCasheaDues).toFixed(2));
      setValue(
        `financialAmountBsS${i}`,
        (watch(`financialAmount${i}`) * card?.dollarRate).toFixed(2)
      );
    }
  };

  const handleAmountChangeBs = (index) => {
    setValue(
      `amount${index}`,
      NaNtoNumber(
        parseFloat(watch(`amountBsS${index}`)) / card.dollarRate
      ).toFixed(2)
    );

    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    let acumulatedAmount = 0;

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      if (i !== index + 1) {
        acumulatedAmount = acumulatedAmount + parseFloat(watch(`amount${i}`));
      }
    }
    const nextAmount = parseFloat(watch('billAmount') - acumulatedAmount);

    if (nextAmount > 0) {
      setValue(`amount${index + 1}`, nextAmount.toFixed(2));
      setValue(
        `amountBsS${index + 1}`,
        (watch(`amount${index + 1}`) * card.dollarRate).toFixed(2)
      );
      calculateIGTF(index + 1);
    }

    // Calculate IGTF
    calculateIGTF(index);
    calculateIGTFTotal();
  };

  const filterPaymentType = () => {
    let options = [...paymentTypeOptions];
    // options?.push({
    //   _id: paymentType?.CASHEA,
    //   name: 'Cashea',
    // });
    if (
      [transactionTypes?.UPGRADE, transactionTypes?.RCV].includes(
        card?.params?.transactionType
      )
    ) {
      return options.filter((option) => {
        return [paymentType?.DE_CONTADO, paymentType?.COURTESY].includes(
          option._id
        );
      });
    }
    if (card?.params?.duePayment === 'cashea') {
      options.push({
        _id: paymentType?.CASHEA,
        name: paymentType?.CASHEA,
      });
    }
    return options;
  };

  const handleFinalPriceChange = (e) => {
    if (
      watch('paymentStrategy') &&
      watch('paymentStrategy') === paymentType?.CASHEA
    ) {
      setValue('paymentMethodsQuantity', '1');
      setValue('billAmount', watch('finalPrice'));
      setValue('amount0', watch('finalPrice'));
      setValue(
        `amountBsS0`,
        NaNtoNumber(parseFloat(watch(`amount0`)) * card.dollarRate).toFixed(2)
      );
      setValue(
        'finalPriceInBsS',
        NaNtoNumber(parseFloat(watch('finalPrice')) * card.dollarRate).toFixed(
          2
        )
      );
    }
  };

  const handlePaymentDateRate = () => {
    getPaymentDateRate();
  };

  const handleCashbackModal = (index, isValid) => {
    setCashbackModal((prevState) => {
      return {
        ...prevState,
        isOpen: !cashbackModal.isOpen,
        paymentNumber: index >= 0 ? index : '',
        amount: parseFloat(watch(`returnedAmount${index}`)),
        amountBsS: parseFloat(watch(`returnedAmountBsS${index}`)),
      };
    });

    if (!isValid) {
      setValue(`cashBackphone${index}`, '');
      setValue(`cashBackbank${index}`, '');
      setValue(`cashBackIdentificationType${index}`, '');
      setValue(`cashBackIdentification${index}`, '');
    }
  };

  const saveCashbackData = () => {
    let isValid = true;

    const dataArray = [
      'cashBackphone',
      'cashBackbank',
      'cashBackIdentificationType',
      'cashBackIdentification',
    ];

    for (let i = 0; i < dataArray.length; i++) {
      setError(`${dataArray[i]}${cashbackModal.paymentNumber}`, {
        type: 'custom',
        message: '',
      });

      if (watch(`cashBackphone${cashbackModal.paymentNumber}`)?.length !== 10) {
        setError(`cashBackphone${cashbackModal.paymentNumber}`, {
          type: 'custom',
          message: 'Ingrese un numero de telefono valido: Ejemplo: 4143579865',
        });
        isValid = false;
        return;
      }

      if (!watch(`${dataArray[i]}${cashbackModal.paymentNumber}`)) {
        setError(`${dataArray[i]}${cashbackModal.paymentNumber}`, {
          type: 'custom',
          message: 'Obligatorio',
        });
        isValid = false;
      }
    }

    if (isValid) {
      handleCashbackModal(0, isValid);
    }
  };

  const form = {
    watch,
    register,
    handleSubmit,
    errors,
    setValue,
    dollarRate: card?.dollarRate,
  };

  const paymentsForm = {
    fileUploaded: fileUploaded,
    params: card?.params,
    form: form,
    control: control,
    transactionType: transactionType,
    options: {
      paymentTypeOptions: filterPaymentType(),
      allPaymentTypeOptions: [
        { name: paymentType?.DE_CONTADO, _id: paymentType?.DE_CONTADO },
        { name: paymentType?.FINANCIADO, _id: paymentType?.FINANCIADO },
        { name: paymentType?.CASHEA, _id: paymentType?.CASHEA },
        { name: paymentType?.COURTESY, _id: paymentType?.COURTESY },
      ],
    },
    onChange: {
      selectUniquePayment: selectUniquePayment,
      handleBillAmountChange: handleBillAmountChange,
      setPaymentType: setPaymentType,
      handleCasheaInitial: handleCasheaInitial,
      handleCasheaQuotas: handleCasheaQuotas,
      handlePaymentDateRate: handlePaymentDateRate,
      handleFinalPriceChange: handleFinalPriceChange,
    },
  };

  const multiplePaymentsTable = {
    header: multiplePaymentsTableHeader,
    validation: { validateIfCanPay: validateIfCanPay },
    fileUploaded: fileUploaded,
    action: { handlePaymentModal: handlePaymentModal },
    onChange: {
      handleAmountChangeBs: handleAmountChangeBs,
      handleAmountChange: handleAmountChange,
      handleMethodChange: handleMethodChange,
      handleIGTFChange: handleIGTFChange,
    },
    dollarRate: card?.dollarRate,
    options: { paymemtMethodOptions: paymemtMethodOptions },
    watch,
    register,
    handleSubmit,
    errors,
  };

  const nextQuotaTable = {
    header: nextQuotaTableHeader,
    watch,
    register,
    errors,
    options: {
      secondQuotaTime: secondQuotaTime,
      casheaQuotaTime: casheaQuotaTime,
    },
  };

  // Show Component only if billAmount is set
  if (!card.form.watch('billAmount') && !card.form.watch('paymentType')) {
    return null;
  }

    const shouldDisableReferenceAndReceipt = (paymentMethod) => {
        const role = authService?.getUserType();
        const hunter = salesRoles.SALES_HUNTER;
        const farmer = salesRoles.SALES_FARMER;
        const counter = salesRoles.SALES_COUNTER;
    
        const notAllowedRoles = [hunter, farmer, counter];
    
        // Nombres de métodos de pago a bloquear
        const blockedMethodNames = [
          'PAGO MÓVIL BANCAMIGA',
          'PAGO MÓVIL BNC',
          'PAGO MÓVIL MERCANTIL',
          'PAGO MÓVIL BANESCO',
          'PAGO MOVIL BANPLUS',
          'PAGO MÓVIL GENERICO',
          'PAGO MÓVIL',
          'C2P BANCAMIGA',
          'TRANSFERENCIA BANCAMIGA',
          'TRANSFERENCIA BNC',
          'TRANSFERENCIA MERCANTIL',
          'TRANSFERENCIA BANESCO',
          'TRANSFERENCIA BANPLUS',
          'TRANSFERENCIA GENERICO',
          'BANK TRANSFER',
          'ZELLE',
          'PAYPAL',
          'BINANCE',
        ];
        const selectedMethod = paymemtMethodOptions.find((p) => p._id === paymentMethod);
        const isBlocked = selectedMethod 
          ? blockedMethodNames.includes(selectedMethod.name) 
          : blockedMethodNames.includes(paymentMethod);
    
        // Si el rol es hunter, farmer o counter (interno o externo)
        // y el método de pago es uno de los bloqueados
        if (
          notAllowedRoles.includes(role?.code || role) &&
          isBlocked
        ) {
          return true;
        }
        return false;
      };


  return (
    <>
      <LoadSpinner show={isloading} />
      <NewPaymentModal
        showErrorAPI={showErrorAPI}
        fileUploaded={fileUploaded}
        setFileUploaded={setFileUploaded}
        getPaymentsData={getPaymentsData}
        // removeImage={removeImage}
        cancelPayment={cancelPayment}
        acceptPayment={acceptPayment}
        selectedMethod={selectedMethod}
        register={register}
        watch={watch}
        dollarRate={card?.dollarRate}
        cashReceiverOptions={cashReceiverOptions}
        payment={payment}
        errors={errors}
        control={control}
        handleReferenceChange={handleReferenceChange}
        handleOwnerChange={handleOwnerChange}
        handleGenericPaymentMethods={handleGenericPaymentMethods}
      />
      <CashbackModal
        cancelPayment={handleCashbackModal}
        acceptPayment={saveCashbackData}
        options={{ paymentMethodOptions: paymemtMethodOptions }}
        register={register}
        errors={errors}
        payment={cashbackModal}
      />
      <div className="col-12">
        <div className="order-card">
          <OderCardHeader open={open} setOpen={setOpen} label={label} />

          {open && (
            <>
              <br />
              {[
                transactionTypes.RENEWAL,
                transactionTypes.MULTIPLE_RENEWAL,
              ].includes(card?.params?.transactionType) &&
              watch('paymentType') === paymentType?.CASHEA_LINK &&
              casheaLink ? (
                <CasheaLinkFlow
                  planName={membership?.membershipPlan}
                  priceUSD={watch('finalPrice')}
                  priceBs={watch('finalPriceInBsS')}
                  membershipId={membership?._id}
                  onQueryPlan={casheaLink.onQueryPlan}
                  onConfirmOrder={casheaLink.onConfirmOrder}
                  onCancel={casheaLink.onCancel}
                  hideNewAffiliation
                />
              ) : (
                <>
                  <PaymentsForm data={paymentsForm} />
                  {!isZeroInitialCashea && (
                    <MultiplePaymentsTable table={multiplePaymentsTable} />
                  )}
                  <NextQuotasTable table={nextQuotaTable} />
                  <CashBackComponent
                    register={register}
                    errors={errors}
                    watch={watch}
                    options={{
                      paymemtMethodOptions: paymemtMethodOptions,
                      filteredMethods: paymemtMethodOptions,
                    }}
                    onChange={{
                      handleCashbackBs: handleCashbackBs,
                      handleCashbackMethodsQuantity: handleCashbackMethodsQuantity,
                    }}
                    handleCashbackModal={handleCashbackModal}
                    handleDrop={handleDrop}
                    cashBackImage={cashBackImage}
                    removeFile={removeFile}
                    errorsDropzone={errorsDropzone}
                    shouldDisableReferenceAndReceipt={shouldDisableReferenceAndReceipt}
                  />

                  {watch('finalPrice') !== 0 && validateButtonName()}
                  {/* {watch('finalPrice') === 0 && (
                                    <ActionButton
                                        label={'Continuar'}
                                        action={() => updateMembershipStatus(membership?._id)}
                                    />
                                )} */}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
